<script>
    import { user_data } from './stores.js';
    import { onMount } from "svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import Iqtemplate from "./components/iqtemplate.svelte";
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    

    onMount(async() => {

    });

</script>

<Iqtemplate>
    <div class="cszinputcontainer">
        <div class="cszinputfieldcontainer">
            <div class="progresstext">3/6</div>
            <div class="csztopcopy">
                Estimated credit score?
            </div>
            <Chipscompnent
            chipsdata={ [
        {s: true, t: "580-619", title:"Fair", cbf:()=>{$user_data.does_qualify = false; $user_data.creditscore = "619";}, n: "#/first_time_home_owner"},
        {s: false, t: "620-659", title:"Good", cbf:()=>{$user_data.does_qualify = (true && $user_data.does_qualify); $user_data.creditscore = "659";}, n: "#/first_time_home_owner"},
        {s: false, t: "660 and above", title:"Excellent", cbf:()=>{$user_data.does_qualify = (true && $user_data.does_qualify); $user_data.creditscore = "700"; }, n: "#/first_time_home_owner"},
            ] }
            />

            <div class="progressbuttonholder">
                <button on:click={()=>{push("#/loan_amount");}} class="backbutton"><span class="backarrowcontainer"><img src="/img/triangle-left-arrow.svg" alt="back arrow" /></span>Go Back</button>
            </div>

        </div>
    </div>

</Iqtemplate>

<style>

</style>